import React, { FormEvent, ReactElement } from 'react';
import {
  Button,
  Col, Heading, LoaderButton, Row, Text,
} from 'idsk-react-components';
import { v4 as uuidv4 } from 'uuid';
import { BackButton } from 'slovlex-idsk-react-components';
import ZaznamSekcieItem from './ZaznamSekcieItem';
import ZaznamSekcie from '../../../../../model/ZaznamSekcie';
import addIcon from '../../../../../../assets/images/icon-plus-dark.svg';

interface Props {
  zaznamySekcie: Array<ZaznamSekcie>;
  setZaznamySekcie: (zaznamySekcie: Array<ZaznamSekcie>) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  clearFieldErrorMessage?: (fieldName: string) => void;
  clearAllFieldErrorMessages?: () => void;
  loading: boolean;
}

const ZaznamySekcieUpdateForm = ({
  zaznamySekcie,
  setZaznamySekcie,
  onSubmit,
  getFieldErrorMessage,
  clearFieldErrorMessage,
  clearAllFieldErrorMessages,
  loading,
}: Props): ReactElement => {
  const addZaznamSekcie = async (): Promise<void> => {
    setZaznamySekcie([...zaznamySekcie, {
      key: uuidv4(), nazov: '', url: '', typ: null, uuid: '',
    }]);
  };

  return (
    <>
      <Heading size="l">Judikáty a rozhodnutia súdov</Heading>
      <form onSubmit={onSubmit} className="admin-termin-create-form">
        {zaznamySekcie?.map((zaznamSekcie, index) => (
          <ZaznamSekcieItem
            key={zaznamSekcie.key || zaznamSekcie.uuid}
            itemList={zaznamySekcie}
            setItemList={setZaznamySekcie}
            itemId={index}
            getFieldErrorMessage={getFieldErrorMessage}
            clearFieldErrorMessage={clearFieldErrorMessage}
            clearAllFieldErrorMessages={clearAllFieldErrorMessages}
          >
            {index === zaznamySekcie.length - 1 && (
              <Button
                size="large"
                onClick={addZaznamSekcie}
                iconBefore={addIcon}
                buttonStyle="third"
              >Pridať judikát/rozhodnutie
              </Button>
            )}
          </ZaznamSekcieItem>
        ))}
        {zaznamySekcie.length === 0 && (
          <>
            <Text className="zaznam-sekcie-item">
              Prázdny zoznam judikátov/rozhodnutí.
            </Text>
            <Button
              size="large"
              onClick={addZaznamSekcie}
              iconBefore={addIcon}
              buttonStyle="third"
            >Pridať judikát/rozhodnutie
            </Button>
          </>
        )}
        <Row className="admin-termin-create__actions">
          <Col width="one-half">
            <LoaderButton
              className="admin-termin-create__create-button"
              loading={loading}
              type="submit"
              size="large"
            >
              Uložiť zmeny
            </LoaderButton>
            <BackButton disabled={loading} />
          </Col>
        </Row>
      </form>
    </>
  );
};

export default ZaznamySekcieUpdateForm;
